import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { FORGET_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions"

// Include Both Helper Files with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeForgetPwd,
  postJwtForgetPwd,
} from "../../../helpers/fakebackend_helper"

const fireBaseBackend = getFirebaseBackend()

// If user is send successfully, send mail link then dispatch redux action's directly from here.
function* forgetUser({ payload: { user, history } }) {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      response = yield call(fireBaseBackend.forgetPassword, user.email);
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      response = yield call(postJwtForgetPwd, { username: user.username });
    } else {
      response = yield call(postFakeForgetPwd, user.username);
    }

    if (response) {
     
      // Check if there's an error in the response
      if (response.isError) {
        
        // If there's an error, dispatch the error message from the response
        yield put(userForgetPasswordError(response.errorMessage || "An error occurred."));
      } else {
        // If no error, dispatch the success message from the response
        yield put(userForgetPasswordSuccess(response));
      }
    } else {
      yield put(userForgetPasswordError("Unexpected error occurred. No response from server."));
    }
  } catch (error) {
    // Catch any unexpected errors (e.g., network errors) and dispatch them
    yield put(userForgetPasswordError(error.message || "An error occurred during the password reset process."));
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)])
}

export default forgetPasswordSaga
